module.exports = __webpack_public_path__ + "img/044f56b.jpg";